import { render, staticRenderFns } from "./PlainText.vue?vue&type=template&id=dd4b9046&"
import script from "./PlainText.vue?vue&type=script&lang=js&"
export * from "./PlainText.vue?vue&type=script&lang=js&"
import style0 from "./PlainText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports